import React, { useEffect, useState } from "react";
import { telemetryService } from "../../../services/TelemetryService";

import BasicEdgeConfigEditor from "../editors/BasicEdgeConfigEditor";
import { useNavigate } from "react-router-dom";

function CreateSingleEdgeConfig({ deviceType, staticContext, ...props }) {
    const { configFile: config, serialNum, isDefaultTemplate } = props;
    const navigate = useNavigate();

    const [newData, setNewData] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    const submitHandler = (e) => {
        e.preventDefault();

        let errors = checkFormDataErrors(newData);

        if (errors?.length) {
            const len = errors.length - 1;
            const newLine = "\r\n";
            let message = "";

            for (let i = 0; i <= len; i++) {
                message += `${i + 1}. ${errors[i]}`;
                if (i !== len) {
                    message += newLine;
                }
            }

            alert(message);

            return;
        }

        if (!serialNum) {
            alert("Enter a device serial number.");

            return;
        } else {
            telemetryService.saveEdgeConfig(serialNum, newData);
        }

        navigate(`/telemetry/edgeConfig/${deviceType.toLowerCase()}`);
    };

    const checkFormDataErrors = (data) => {
        let errors = [];

        if (deviceType === "Polaris" && isDefaultTemplate) {
            if (isNaN(serialNum)) errors.push("Serial Number must be a number.");
            if (!isNaN(serialNum) && serialNum < 500000) errors.push("Serial Number must be greater than 500000.");
        } else if (deviceType !== "Polaris") {
            let {
                scan_settings: { azRange, elevRange, radiusRange, x_range, y_range, z_range, scan_interval },
                compressed_scan_settings: { cubeEdge_m },
            } = data;

            if (elevRange[0] > elevRange[1]) errors.push("First elevRange should be less than the second.");
            if (radiusRange[0] > radiusRange[1]) errors.push("First radiusRange should be less than the second.");
            if (x_range[0] > x_range[1]) errors.push("First x_range should be less than the second.");
            if (y_range[0] > y_range[1]) errors.push("First y_range should be less than the second.");
            if (z_range[0] > z_range[1]) errors.push("First z_range should be less than the second.");
            if (scan_interval[0] !== null) errors.push("Scan Interval value for rawScan should be null.");
            if (scan_interval[2] !== null) errors.push("Scan Interval value for conductorFit should be null.");
            if (!cubeEdge_m % 1 !== 0) errors.push("CubeEdge value should be a float.");
        }

        return errors;
    };

    return (
        <>
            <BasicEdgeConfigEditor
                config={config}
                handleData={setNewData}
                submitHandler={submitHandler}
                deviceType={deviceType}
                isDefaultTemplate={isDefaultTemplate}
            />
        </>
    );
}

export default CreateSingleEdgeConfig;
